export default {"src":"/_next/static/media/dots.96badc82.svg","height":100,"width":179};